import { render, staticRenderFns } from "./OrdersLoading.vue?vue&type=template&id=cc9d6a6c&"
import script from "./OrdersLoading.vue?vue&type=script&lang=js&"
export * from "./OrdersLoading.vue?vue&type=script&lang=js&"
import style0 from "./OrdersLoading.vue?vue&type=style&index=0&id=cc9d6a6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports